export enum ChatbotRole {
	BOT = 'BOT',
	USER = 'USER'
}

export interface ChatbotIcons {
	chatbotIcon: string;
	userIcon: string;
}

export interface ChatbotMsg {
	role: ChatbotRole;
	content: string;
	error?: boolean;
}
